export default __webpack_public_path__ + "static/media/instagram_icon.dfb7d4d3.png";